"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reasons = exports.AppContext = void 0;
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var api_1 = require("../../api");
var loading_modal_1 = __importDefault(require("../../components/loading-modal"));
var cancel_subscription_1 = require("../../mutations/cancel-subscription");
var record_snack_time_event_1 = require("../../record-snack-time-event");
var adjust_frequency_1 = __importDefault(require("./adjust-frequency"));
var final_comments_1 = __importDefault(require("./final-comments"));
var offer_discount_1 = __importDefault(require("./offer-discount"));
var offer_fundamentals_1 = __importDefault(require("./offer-fundamentals"));
var reason_choices_1 = __importDefault(require("./reason-choices"));
var show_different_diapering_1 = __importDefault(require("./show-different-diapering"));
var skip_shipment_1 = __importDefault(require("./skip-shipment"));
var wipesless_bundle_1 = __importDefault(require("./wipesless-bundle"));
var createContext = React.createContext, useEffect = React.useEffect, useState = React.useState;
var minCommentsLength = 5;
exports.AppContext = createContext({
    comments: '',
    goNext: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); },
    minCommentsLength: minCommentsLength,
    recordSaveAndAcceptedOfferDeflectionInSnacktime: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); },
    setCurrentStep: function () { return undefined; },
    setComments: function () { return undefined; },
    setReason: function () { return undefined; },
    submit: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); },
});
// if you're adding a reason tied to an offerDiscount, make sure to also add it to the apply-discount-to-save resolver in subscriptions-api
exports.reasons = [
    { key: 'econ', title: 'Economy' },
    { key: 'freq', title: 'Frequency' },
    { key: 'price', title: 'Price' },
    { key: 'wipes', title: 'Wipes' },
    { key: 'perf', title: 'Performance' },
    { key: 'potty', title: 'Potty Training' },
    { key: 'store', title: 'Buy In-Store' },
    { key: 'other', title: 'Other' },
];
exports.default = (function (_a) {
    var groupedSubscription = _a.groupedSubscription, bundleType = _a.bundleType, handleEditItems = _a.handleEditItems, reason = _a.reason, setReason = _a.setReason;
    var cancel = window.accountApp.settings.cancel;
    // check if the customer was saved by onetimes vitamin offer and set the first modal to onetimes-offer if customer was not
    // if you're adding a onetimes offer type (e.g. vitamins), be sure to add to the onetimes_offer_type dropdown in account-cancel-subscription.liquid
    var _b = __read(useState('skip-shipment'), 2), currentStep = _b[0], setCurrentStep = _b[1];
    var _c = __read(useState(''), 2), offerReason = _c[0], setOfferReason = _c[1];
    var _d = __read(useState(''), 2), comments = _d[0], setComments = _d[1];
    var _e = __read(useState(false), 2), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = (0, react_query_1.useMutation)("cancelSubscription", function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(cancel_subscription_1.CANCEL_SUBSCRIPTION, variables); }, {
        onSuccess: function () {
            window.location.href = '/account';
        },
    }), cancelSubscription = _f.mutateAsync, cancelSubscriptionError = _f.error;
    // tell hotjar that the cancel modal was opened
    useEffect(function () {
        if (window.hj) {
            window.hj('trigger', 'opened_cancel_modal');
        }
    }, []);
    var goNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bundleTypes;
        return __generator(this, function (_a) {
            switch (currentStep) {
                case 'skip-shipment':
                    return [2 /*return*/, setCurrentStep('reason-choices')];
                case 'reason-choices':
                    switch (reason === null || reason === void 0 ? void 0 : reason.key) {
                        case 'econ':
                            setOfferReason(reason.key);
                            return [2 /*return*/, setCurrentStep('offer-discount')];
                        case 'price':
                            setOfferReason(reason.key);
                            return [2 /*return*/, setCurrentStep('offer-discount')];
                        case 'wipes':
                            return [2 /*return*/, setCurrentStep('wipesless-bundle')];
                        case 'freq':
                            return [2 /*return*/, setCurrentStep('adjust-frequency')];
                        case 'perf':
                            return [2 /*return*/, setCurrentStep('show-nighttimes')];
                        case 'potty':
                            return [2 /*return*/, setCurrentStep('show-training-pants')];
                        case 'store':
                            return [2 /*return*/, setCurrentStep(['Diaper', 'Training Pant'].includes(bundleType) && cancel.enableFundamentalsSave ? 'offer-fundamentals' : 'final-comments')];
                        case 'other':
                            bundleTypes = ['Diaper', 'Training Pant'];
                            if (bundleTypes.includes(bundleType)) {
                                setOfferReason(reason.key);
                                return [2 /*return*/, setCurrentStep('offer-discount')];
                            }
                            return [2 /*return*/, setCurrentStep('final-comments')];
                        default:
                            return [2 /*return*/, setCurrentStep('final-comments')];
                    }
                case 'show-training-pants':
                    return [2 /*return*/, setCurrentStep(cancel.enableFundamentalsSave ? 'offer-fundamentals' : 'final-comments')];
                case 'offer-discount':
                    return [2 /*return*/, setCurrentStep('wipesless-bundle')];
                case 'wipesless-bundle':
                    return [2 /*return*/, setCurrentStep('final-comments')];
                default:
                    return [2 /*return*/, setCurrentStep('final-comments')];
            }
            return [2 /*return*/];
        });
    }); };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    return [4 /*yield*/, cancelSubscription({
                            comments: comments,
                            reason: (reason === null || reason === void 0 ? void 0 : reason.title) || 'Other',
                            subscriptionId: groupedSubscription.subscription.id,
                        })];
                case 1:
                    _a.sent();
                    window.location.href = '/account';
                    return [2 /*return*/];
            }
        });
    }); };
    // Emitting two different events at once is kind of weird, but we're doing this to produce analytics that match Brightback's while maintaining our own
    // legacy charts in Sigma. Brightback considers a save to occur after a deflection has sat for 30 days without a cancellation, while our legacy analytics
    // consider a save to occur immediately when an offer is accepted. Emitting two events is a simple way to support the new and legacy charts.
    var recordSaveAndAcceptedOfferDeflectionInSnacktime = function (save) { return __awaiter(void 0, void 0, void 0, function () {
        var savePromise, deflectPromise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    savePromise = (0, record_snack_time_event_1.recordSnackTimeAction)('AcceptedCancellationSave', groupedSubscription.subscription.id, { reason: reason === null || reason === void 0 ? void 0 : reason.title, save: save });
                    deflectPromise = (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, groupedSubscription.subscription.id, {
                        deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                        reason: reason === null || reason === void 0 ? void 0 : reason.title,
                    });
                    return [4 /*yield*/, savePromise];
                case 1:
                    _a.sent();
                    return [2 /*return*/, deflectPromise];
            }
        });
    }); };
    var contextValue = {
        bundleType: bundleType,
        comments: comments,
        goNext: goNext,
        groupedSubscription: groupedSubscription,
        minCommentsLength: minCommentsLength,
        reason: reason,
        recordSaveAndAcceptedOfferDeflectionInSnacktime: recordSaveAndAcceptedOfferDeflectionInSnacktime,
        setCurrentStep: setCurrentStep,
        setComments: setComments,
        setReason: setReason,
        submit: submit,
    };
    return (React.createElement(exports.AppContext.Provider, { value: contextValue },
        React.createElement(loading_modal_1.default, { error: cancelSubscriptionError, isLoading: isSubmitting }),
        (function () {
            switch (currentStep) {
                case 'skip-shipment':
                    return React.createElement(skip_shipment_1.default, null);
                case 'adjust-frequency':
                    return React.createElement(adjust_frequency_1.default, null);
                case 'reason-choices':
                    return React.createElement(reason_choices_1.default, null);
                case 'offer-discount':
                    return React.createElement(offer_discount_1.default, { offerReason: offerReason });
                case 'offer-fundamentals':
                    return React.createElement(offer_fundamentals_1.default, null);
                case 'final-comments':
                    return React.createElement(final_comments_1.default, null);
                case 'wipesless-bundle':
                    return React.createElement(wipesless_bundle_1.default, null);
                case 'show-nighttimes':
                    return (React.createElement(show_different_diapering_1.default, { topLine: cancel.nighttimeDiaperSaveTopline, title: cancel.nighttimeDiaperSaveTitle, buttonText: cancel.nighttimeDiaperSaveButton, variantSizes: cancel.nighttimeDiaperVariantSizes, gaDivId: 'account-nighttimes-save-btn', bundleTypeToShow: 'Diapers', handleEditItems: handleEditItems }));
                case 'show-training-pants':
                    return (React.createElement(show_different_diapering_1.default, { topLine: cancel.trainingPantsSaveTopline, title: cancel.trainingPantsSaveTitle, diaperProductImage: cancel.trainingPantsDiaperImage, body: cancel.trainingPantsSaveBody, buttonText: cancel.trainingPantsSaveButton, gaDivId: 'account-training-pants-save-btn', bundleTypeToShow: 'TrainingPants', handleEditItems: handleEditItems }));
            }
        })()));
});
